import { api } from '@xtnd/web/shared/api';

/**
 * Image asset interface
 */
export interface ImageAsset {
  imageId: string;
  originalName: string;
  mimeType: string;
  size: number;
  dimensions?: {
    width: number;
    height: number;
  };
  description?: string;
  previewUrl?: string;
  downloadUrl?: string;
  placeholderUrl?: string;
  createdAt: string;
}

/**
 * Response interface for image list
 */
export interface ImageAssetsResponse {
  images: ImageAsset[];
}

/**
 * Response interface for image upload
 */
export interface ImageUploadResponse {
  imageId: string;
  message: string;
}

/**
 * Response interface for image deletion
 */
export interface ImageDeleteResponse {
  message: string;
}

/**
 * API service for image asset management
 */
class ImageAssetsApi {
  /**
   * Get list of all image assets
   * @returns Promise with image assets
   */
  async getImages(): Promise<ImageAssetsResponse> {
    return api.get<ImageAssetsResponse>('/templates/images');
  }

  /**
   * Upload a new image asset
   * @param formData - FormData containing image file and metadata
   * @returns Promise with upload result
   */
  async uploadImage(formData: FormData): Promise<ImageUploadResponse> {
    return api.post<ImageUploadResponse>('/templates/images/upload', formData);
  }

  /**
   * Delete an image asset
   * @param imageId - ID of image to delete
   * @returns Promise with deletion result
   */
  async deleteImage(imageId: string): Promise<ImageDeleteResponse> {
    return api.delete<ImageDeleteResponse>(`/templates/images/${imageId}`);
  }
}

export const imageAssetsApi = new ImageAssetsApi();

